import { gsap } from '../vendor/gsap';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';
import addTranslateMinusYAnimation from '../lib/add-translate-minus-y-animation';
import addTranslateMinusZAnimation from '../lib/add-translat-minus-z-animation';
import addSimpleOpacityAnimation from '../lib/add-simple-opacity-animation';

gsap.registerPlugin(ScrollTrigger);

const moduleSelector = '.scheme:not(.scheme-simple)';
const moduleCallBack = (moduleElement, query, queryAll) => {
    const decor = query('.scheme-decor');
    const row = query('.scheme-layout-row');
    const columns = queryAll('.scheme-layout-col');
    const titles = queryAll('.scheme-layout-col .title');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: moduleElement,
            start: 'top 100%',
        },
    });
    if (moduleElement) transparentBeforeAnimation(moduleElement, timeline);
    if (moduleElement) addTranslateMinusYAnimation(timeline, moduleElement, 0.3);
    if (decor) addTranslateMinusZAnimation(timeline, decor, 0.6);
    if (row) addTranslateMinusZAnimation(timeline, row, 0.8);
    if (columns.length > 0) addSimpleOpacityAnimation(timeline, columns, 0.8);
    if (titles.length > 0) addSimpleOpacityAnimation(timeline, titles, 1.2);

    const activeState = (col, index, parent) => {
        columns.forEach((item) => {
            item.classList.remove('active');
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < 10; i++) {
                parent.classList.remove(`active-col-${i}`);
            }
        });
        parent.classList.add(`active-col-${index}`);
        col.classList.toggle('active');
    };
    const inactiveState = (col, parent) => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 10; i++) {
            parent.classList.remove(`active-col-${i}`);
        }
        col.classList.toggle('active');
    };

    columns.forEach((item, index) => {
        const parent = item.closest('.scheme-layout-row');
        item.addEventListener('click', () => {
            // eslint-disable-next-line no-unused-expressions
            item.classList.contains('active') ? inactiveState(item, parent) : activeState(item, index, parent);
        });
    });
};

export { moduleSelector, moduleCallBack };
